import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSidebarInteraction.meta';

export type UseTrackSidebarInteractionParams = {
  type:
    | 'board'
    | 'library'
    | 'search'
    | 'saved_searches'
    | 'people'
    | 'recently_added'
    | 'recently_deleted'
    | 'skills'
    | 'automations'
    | 'my_uploads'
    | 'my_favorites'
    | 'recently_modified'
    | 'unused_items'
    | 'untagged_items'
    | 'share_links'
    | 'canvases'
    | 'creative_performance'
    | 'context_sources'
    | 'settings';
  action: 'expand' | 'collapse' | 'create_board' | 'open_sub_menu' | 'link_click' | 'link_click_and_expand';
};

export const useTrackSidebarInteraction = () => {
  const { track } = useAnalyticsUtilities();

  const trackSidebarInteraction = useCallback(
    (params: UseTrackSidebarInteractionParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSidebarInteraction };
};
